module.exports = {"locale":"en"}


//////////////////
// WEBPACK FOOTER
// ./config/i18nConfig.json
// module id = 1764
// module chunks = 0